module.exports = __webpack_public_path__ + "media/images/flags/16/China-e4fdf09e1b260468e3b74b198f7075cd.png";